import { IrisMenuItemI } from '@iris/common/models/IrisMenuItem';

export interface MenuItemNodeI {
  name: string;
  title?: string;
  shortTitle?: string;
  children?: MenuItemNodeI[];
  visible?: boolean;
  open?: boolean;
  enabled?: boolean;
  translations?: { name?: unknown };
  url?: string;
  module?: string;
  menuType?: string;
  moduleType?: string;
  productId?: number;
  icon?: string;

  $title: string;
  $active?: boolean;
  $parent?: MenuItemNodeI;
  $hash?: number;
}

export class MenuItemNode implements MenuItemNodeI {
  name: string;
  title?: string;
  shortTitle?: string;
  children?: MenuItemNodeI[];
  visible?: boolean;
  open?: boolean;
  enabled?: boolean;
  translations?: { name: unknown };
  url?: string;
  module?: string;
  menuType?: string;
  moduleType?: string;
  productId?: number;
  icon?: string;

  $title: string;
  $active?: boolean;
  $parent?: MenuItemNodeI;
  $hash?: number;

  constructor(init?: Partial<MenuItemNodeI>) {
    Object.assign(this, init);
  }

  static fromMenuItem(item: IrisMenuItemI, getTitleFn: (item: IrisMenuItemI) => string): MenuItemNode {
    return new MenuItemNode({
      ...item,
      $title: getTitleFn(item),
      $hash: item.children ? this.getHash(item) : undefined,
      children: (item.children || [])
        .filter(child => child.showInQuickNavigation)
        .map(child => MenuItemNode.fromMenuItem(child, getTitleFn)),
    });
  }

  private static getHash(menuItem: IrisMenuItemI): number {
    const title = menuItem.shortTitle || menuItem.title;
    let h = 0xdeadbeef;

    for (let i = 0; i < title.length; i++) {
      h = Math.imul(h ^ title.charCodeAt(i), 2654435761);
    }

    return (h ^ h >>> 16) >>> 0;
  }
}
